import styled from 'styled-components';
import Container from 'components/Container';

export const PaddedContainer = styled(Container)`
  margin-bottom: 5vh;
`;

export const PageWrapper = styled.div`
  background-image: url(${props => props.backgroundImage});
  background-position: 50% 50%;
  background-size: cover;
  background-color: ${props => props.backgroundColor || 'transparent'};
  width: ${props => props.wrapperWidth || '100%'};
  padding-top: calc(64px + 3vh);
  display: flex;
  align-items: center;
`;

export const MainWrapper = styled.div`
  display: flex;
  align-items: stretch;
  min-height: 102vh;
  width: 100%;
  margin-top: -64px;

  @media (max-width: 1100px) {
    flex-direction: column;
    ${PageWrapper} {
      width: 100%;
    }
  }
`;
